import type { ApiResponse } from '@klaro7/shared-types';

import api from '@/lib/api';

export interface RequestCodeResult {
  sentTo: string;
  expiresInSeconds: number;
  resendInSeconds: number;
}

export async function requestPhoneCode(phone: string): Promise<RequestCodeResult> {
  const res = await api.post<ApiResponse<RequestCodeResult>>('/phone/verify/request', { phone });
  return res.data.data;
}

export async function confirmPhoneCode(code: string): Promise<{ phoneVerified: boolean }> {
  const res = await api.post<ApiResponse<{ phoneVerified: boolean }>>('/phone/verify/confirm', {
    code,
  });
  return res.data.data;
}

export async function cancelPendingPhone(): Promise<void> {
  await api.delete('/phone/pending');
}
